// ----------------------------------------------------------------------

import { alpha } from '@mui/material';

export default function Skeleton(theme) {
  return {
    MuiSkeleton: {
      defaultProps: {
        animation: 'wave',
      },

      styleOverrides: {
        root: {
          backgroundColor: alpha('#fff', 0.2),
        },
      },
    },
  };
}
